module.exports = __webpack_public_path__ + "static/inci_aku-2f43ba94606049358aa54cba1471fb9b.png";